var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-10" },
    [
      _c(
        "md-card",
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c("strong", [
                          _vm._v("\n              Coach Revisions "),
                          _c("span", [
                            _vm._v("(" + _vm._s(_vm.revisions.length) + ")")
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c("md-card-content", { staticClass: "comments" }, [
                    _vm.revisions.length
                      ? _c(
                          "div",
                          { staticClass: "activity-log" },
                          _vm._l(_vm.revisions, function(revision, index) {
                            return _c(
                              "div",
                              {
                                key: revision._id,
                                staticClass:
                                  "revision-block p-4 border rounded mb-4 bg-gray-50"
                              },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "font-semibold mb-2" },
                                  [_vm._v("Revision " + _vm._s(index + 1))]
                                ),
                                _vm._v(" "),
                                _c("p", [_c("strong", [_vm._v("Draft:")])]),
                                _vm._v(" "),
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(_vm._s(revision.draft))
                                ]),
                                _vm._v(" "),
                                revision.feedback
                                  ? _c("div", [
                                      _c(
                                        "h5",
                                        { staticClass: "font-semibold mt-2" },
                                        [_vm._v("Feedback")]
                                      ),
                                      _vm._v(" "),
                                      revision.feedback.strengths &&
                                      revision.feedback.strengths.length
                                        ? _c("div", [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v("Strengths:")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              _vm._l(
                                                revision.feedback.strengths,
                                                function(item, sIndex) {
                                                  return _c(
                                                    "li",
                                                    { key: sIndex },
                                                    [_vm._v(" " + _vm._s(item))]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      revision.feedback.improvements &&
                                      revision.feedback.improvements.length
                                        ? _c("div", [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v("Improvements:")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              _vm._l(
                                                revision.feedback.improvements,
                                                function(item, iIndex) {
                                                  return _c(
                                                    "li",
                                                    { key: iIndex },
                                                    [_vm._v(" " + _vm._s(item))]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mt-2 text-sm text-gray-600" },
                                  [
                                    _c("p", [
                                      _c("strong", [_vm._v("Overall Score:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            revision.feedback.overall_score
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [_vm._v("Created:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("momentDate")(
                                              revision.created_at
                                            )
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "text-gray-500 p-4" }, [
                          _vm._v("\n            No revisions yet.\n          ")
                        ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4208937a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4208937a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoachLog.vue
// module id = null
// module chunks = 